import type { IErrorType } from '../../constants/types';
import type {
    SandboxAssignmentSubmission,
    SandboxClassAsset,
    SandboxCourse,
    SandboxCourseRating,
    SandboxPaymentHistoryItem,
} from '../../utils/sandboxCourseApi';
import type {
    HostOfficeHoursBooking,
    SandboxOfficeHoursConfig,
    StudentOfficeHoursBooking,
} from '../../utils/sandboxOfficeHoursApi';

export const types = {
    FETCH_EXPLORE: 'sandbox/FETCH_EXPLORE',
    FETCH_EXPLORE_SUCCESS: 'sandbox/FETCH_EXPLORE_SUCCESS',
    FETCH_EXPLORE_FAIL: 'sandbox/FETCH_EXPLORE_FAIL',

    FETCH_COURSE: 'sandbox/FETCH_COURSE',
    FETCH_COURSE_SUCCESS: 'sandbox/FETCH_COURSE_SUCCESS',
    FETCH_COURSE_FAIL: 'sandbox/FETCH_COURSE_FAIL',

    FETCH_TEACHER_DASHBOARD: 'sandbox/FETCH_TEACHER_DASHBOARD',
    FETCH_TEACHER_DASHBOARD_SUCCESS: 'sandbox/FETCH_TEACHER_DASHBOARD_SUCCESS',
    FETCH_TEACHER_DASHBOARD_FAIL: 'sandbox/FETCH_TEACHER_DASHBOARD_FAIL',

    CREATE_COURSE: 'sandbox/CREATE_COURSE',
    CREATE_COURSE_SUCCESS: 'sandbox/CREATE_COURSE_SUCCESS',
    CREATE_COURSE_FAIL: 'sandbox/CREATE_COURSE_FAIL',

    UPDATE_COURSE: 'sandbox/UPDATE_COURSE',
    UPDATE_COURSE_SUCCESS: 'sandbox/UPDATE_COURSE_SUCCESS',
    UPDATE_COURSE_FAIL: 'sandbox/UPDATE_COURSE_FAIL',

    PUBLISH_COURSE: 'sandbox/PUBLISH_COURSE',
    PUBLISH_COURSE_SUCCESS: 'sandbox/PUBLISH_COURSE_SUCCESS',
    PUBLISH_COURSE_FAIL: 'sandbox/PUBLISH_COURSE_FAIL',

    ENROLL_FREE: 'sandbox/ENROLL_FREE',
    ENROLL_FREE_SUCCESS: 'sandbox/ENROLL_FREE_SUCCESS',
    ENROLL_FREE_FAIL: 'sandbox/ENROLL_FREE_FAIL',

    COMPLETE_PURCHASE: 'sandbox/COMPLETE_PURCHASE',
    COMPLETE_PURCHASE_SUCCESS: 'sandbox/COMPLETE_PURCHASE_SUCCESS',
    COMPLETE_PURCHASE_FAIL: 'sandbox/COMPLETE_PURCHASE_FAIL',

    SAVE_PROGRESS: 'sandbox/SAVE_PROGRESS',
    SAVE_PROGRESS_SUCCESS: 'sandbox/SAVE_PROGRESS_SUCCESS',
    SAVE_PROGRESS_FAIL: 'sandbox/SAVE_PROGRESS_FAIL',

    FETCH_LESSON_PROJECT: 'sandbox/FETCH_LESSON_PROJECT',
    FETCH_LESSON_PROJECT_SUCCESS: 'sandbox/FETCH_LESSON_PROJECT_SUCCESS',
    FETCH_LESSON_PROJECT_FAIL: 'sandbox/FETCH_LESSON_PROJECT_FAIL',

    FETCH_MY_ENROLLMENTS: 'sandbox/FETCH_MY_ENROLLMENTS',
    FETCH_MY_ENROLLMENTS_SUCCESS: 'sandbox/FETCH_MY_ENROLLMENTS_SUCCESS',
    FETCH_MY_ENROLLMENTS_FAIL: 'sandbox/FETCH_MY_ENROLLMENTS_FAIL',

    FETCH_MY_ASSIGNMENTS: 'sandbox/FETCH_MY_ASSIGNMENTS',
    FETCH_MY_ASSIGNMENTS_SUCCESS: 'sandbox/FETCH_MY_ASSIGNMENTS_SUCCESS',
    FETCH_MY_ASSIGNMENTS_FAIL: 'sandbox/FETCH_MY_ASSIGNMENTS_FAIL',

    FETCH_TEACHER_REVIEWS: 'sandbox/FETCH_TEACHER_REVIEWS',
    FETCH_TEACHER_REVIEWS_SUCCESS: 'sandbox/FETCH_TEACHER_REVIEWS_SUCCESS',
    FETCH_TEACHER_REVIEWS_FAIL: 'sandbox/FETCH_TEACHER_REVIEWS_FAIL',

    SUBMIT_ASSIGNMENT: 'sandbox/SUBMIT_ASSIGNMENT',
    SUBMIT_ASSIGNMENT_SUCCESS: 'sandbox/SUBMIT_ASSIGNMENT_SUCCESS',
    SUBMIT_ASSIGNMENT_FAIL: 'sandbox/SUBMIT_ASSIGNMENT_FAIL',

    FETCH_LESSON_ASSIGNMENTS: 'sandbox/FETCH_LESSON_ASSIGNMENTS',
    FETCH_LESSON_ASSIGNMENTS_SUCCESS: 'sandbox/FETCH_LESSON_ASSIGNMENTS_SUCCESS',
    FETCH_LESSON_ASSIGNMENTS_FAIL: 'sandbox/FETCH_LESSON_ASSIGNMENTS_FAIL',

    REVIEW_ASSIGNMENT: 'sandbox/REVIEW_ASSIGNMENT',
    REVIEW_ASSIGNMENT_SUCCESS: 'sandbox/REVIEW_ASSIGNMENT_SUCCESS',
    REVIEW_ASSIGNMENT_FAIL: 'sandbox/REVIEW_ASSIGNMENT_FAIL',

    FETCH_CLASS_ASSETS: 'sandbox/FETCH_CLASS_ASSETS',
    FETCH_CLASS_ASSETS_SUCCESS: 'sandbox/FETCH_CLASS_ASSETS_SUCCESS',
    FETCH_CLASS_ASSETS_FAIL: 'sandbox/FETCH_CLASS_ASSETS_FAIL',

    ADD_CLASS_ASSET: 'sandbox/ADD_CLASS_ASSET',
    ADD_CLASS_ASSET_SUCCESS: 'sandbox/ADD_CLASS_ASSET_SUCCESS',
    ADD_CLASS_ASSET_FAIL: 'sandbox/ADD_CLASS_ASSET_FAIL',

    UPDATE_CLASS_ASSET: 'sandbox/UPDATE_CLASS_ASSET',
    UPDATE_CLASS_ASSET_SUCCESS: 'sandbox/UPDATE_CLASS_ASSET_SUCCESS',
    UPDATE_CLASS_ASSET_FAIL: 'sandbox/UPDATE_CLASS_ASSET_FAIL',

    DELETE_CLASS_ASSET: 'sandbox/DELETE_CLASS_ASSET',
    DELETE_CLASS_ASSET_SUCCESS: 'sandbox/DELETE_CLASS_ASSET_SUCCESS',
    DELETE_CLASS_ASSET_FAIL: 'sandbox/DELETE_CLASS_ASSET_FAIL',

    DOWNLOAD_CLASS_ASSET: 'sandbox/DOWNLOAD_CLASS_ASSET',
    DOWNLOAD_CLASS_ASSET_SUCCESS: 'sandbox/DOWNLOAD_CLASS_ASSET_SUCCESS',
    DOWNLOAD_CLASS_ASSET_FAIL: 'sandbox/DOWNLOAD_CLASS_ASSET_FAIL',

    UPSERT_COURSE_RATING: 'sandbox/UPSERT_COURSE_RATING',
    UPSERT_COURSE_RATING_SUCCESS: 'sandbox/UPSERT_COURSE_RATING_SUCCESS',
    UPSERT_COURSE_RATING_FAIL: 'sandbox/UPSERT_COURSE_RATING_FAIL',

    FETCH_PAYMENT_HISTORY: 'sandbox/FETCH_PAYMENT_HISTORY',
    FETCH_PAYMENT_HISTORY_SUCCESS: 'sandbox/FETCH_PAYMENT_HISTORY_SUCCESS',
    FETCH_PAYMENT_HISTORY_FAIL: 'sandbox/FETCH_PAYMENT_HISTORY_FAIL',

    FETCH_MY_OFFICE_HOURS: 'sandbox/FETCH_MY_OFFICE_HOURS',
    FETCH_MY_OFFICE_HOURS_SUCCESS: 'sandbox/FETCH_MY_OFFICE_HOURS_SUCCESS',
    FETCH_MY_OFFICE_HOURS_FAIL: 'sandbox/FETCH_MY_OFFICE_HOURS_FAIL',

    UPSERT_MY_OFFICE_HOURS: 'sandbox/UPSERT_MY_OFFICE_HOURS',
    UPSERT_MY_OFFICE_HOURS_SUCCESS: 'sandbox/UPSERT_MY_OFFICE_HOURS_SUCCESS',
    UPSERT_MY_OFFICE_HOURS_FAIL: 'sandbox/UPSERT_MY_OFFICE_HOURS_FAIL',

    FETCH_GOOGLE_AUTHORIZE_URL: 'sandbox/FETCH_GOOGLE_AUTHORIZE_URL',
    FETCH_GOOGLE_AUTHORIZE_URL_SUCCESS: 'sandbox/FETCH_GOOGLE_AUTHORIZE_URL_SUCCESS',
    FETCH_GOOGLE_AUTHORIZE_URL_FAIL: 'sandbox/FETCH_GOOGLE_AUTHORIZE_URL_FAIL',

    FETCH_TEACHER_OFFICE_HOURS: 'sandbox/FETCH_TEACHER_OFFICE_HOURS',
    FETCH_TEACHER_OFFICE_HOURS_SUCCESS: 'sandbox/FETCH_TEACHER_OFFICE_HOURS_SUCCESS',
    FETCH_TEACHER_OFFICE_HOURS_FAIL: 'sandbox/FETCH_TEACHER_OFFICE_HOURS_FAIL',

    FETCH_TEACHER_OH_AVAILABILITY: 'sandbox/FETCH_TEACHER_OH_AVAILABILITY',
    FETCH_TEACHER_OH_AVAILABILITY_SUCCESS: 'sandbox/FETCH_TEACHER_OH_AVAILABILITY_SUCCESS',
    FETCH_TEACHER_OH_AVAILABILITY_FAIL: 'sandbox/FETCH_TEACHER_OH_AVAILABILITY_FAIL',

    BOOK_TEACHER_OFFICE_HOURS: 'sandbox/BOOK_TEACHER_OFFICE_HOURS',
    BOOK_TEACHER_OFFICE_HOURS_SUCCESS: 'sandbox/BOOK_TEACHER_OFFICE_HOURS_SUCCESS',
    BOOK_TEACHER_OFFICE_HOURS_FAIL: 'sandbox/BOOK_TEACHER_OFFICE_HOURS_FAIL',

    FETCH_HOST_BOOKINGS: 'sandbox/FETCH_HOST_BOOKINGS',
    FETCH_HOST_BOOKINGS_SUCCESS: 'sandbox/FETCH_HOST_BOOKINGS_SUCCESS',
    FETCH_HOST_BOOKINGS_FAIL: 'sandbox/FETCH_HOST_BOOKINGS_FAIL',

    CANCEL_HOST_BOOKING: 'sandbox/CANCEL_HOST_BOOKING',
    CANCEL_HOST_BOOKING_SUCCESS: 'sandbox/CANCEL_HOST_BOOKING_SUCCESS',
    CANCEL_HOST_BOOKING_FAIL: 'sandbox/CANCEL_HOST_BOOKING_FAIL',

    FETCH_STUDENT_BOOKINGS: 'sandbox/FETCH_STUDENT_BOOKINGS',
    FETCH_STUDENT_BOOKINGS_SUCCESS: 'sandbox/FETCH_STUDENT_BOOKINGS_SUCCESS',
    FETCH_STUDENT_BOOKINGS_FAIL: 'sandbox/FETCH_STUDENT_BOOKINGS_FAIL',

    CANCEL_STUDENT_BOOKING: 'sandbox/CANCEL_STUDENT_BOOKING',
    CANCEL_STUDENT_BOOKING_SUCCESS: 'sandbox/CANCEL_STUDENT_BOOKING_SUCCESS',
    CANCEL_STUDENT_BOOKING_FAIL: 'sandbox/CANCEL_STUDENT_BOOKING_FAIL',

    RESCHEDULE_STUDENT_BOOKING: 'sandbox/RESCHEDULE_STUDENT_BOOKING',
    RESCHEDULE_STUDENT_BOOKING_SUCCESS: 'sandbox/RESCHEDULE_STUDENT_BOOKING_SUCCESS',
    RESCHEDULE_STUDENT_BOOKING_FAIL: 'sandbox/RESCHEDULE_STUDENT_BOOKING_FAIL',

    REQUEST_STUDENT_OH_REFUND: 'sandbox/REQUEST_STUDENT_OH_REFUND',
    REQUEST_STUDENT_OH_REFUND_SUCCESS: 'sandbox/REQUEST_STUDENT_OH_REFUND_SUCCESS',
    REQUEST_STUDENT_OH_REFUND_FAIL: 'sandbox/REQUEST_STUDENT_OH_REFUND_FAIL',

    UPLOAD_COVER_IMAGE: 'sandbox/UPLOAD_COVER_IMAGE',
    UPLOAD_COVER_IMAGE_SUCCESS: 'sandbox/UPLOAD_COVER_IMAGE_SUCCESS',
    UPLOAD_COVER_IMAGE_FAIL: 'sandbox/UPLOAD_COVER_IMAGE_FAIL',

    UPLOAD_CLASS_ASSET_ZIP: 'sandbox/UPLOAD_CLASS_ASSET_ZIP',
    UPLOAD_CLASS_ASSET_ZIP_SUCCESS: 'sandbox/UPLOAD_CLASS_ASSET_ZIP_SUCCESS',
    UPLOAD_CLASS_ASSET_ZIP_FAIL: 'sandbox/UPLOAD_CLASS_ASSET_ZIP_FAIL',
};

export type ISandboxExploreParams = {
    q?: string;
    category?: string;
    featured?: boolean;
    min_rating?: number;
    sort?: 'rating' | string;
    page?: number;
};

export type ISandboxExploreResult = {
    items: SandboxCourse[];
    total: number;
    page: number;
    limit: number;
};

export type ISandboxClassAssetsResult = {
    assets?: SandboxClassAsset[];
    can_download?: boolean;
    can_manage?: boolean;
};

export type ISandboxPaymentHistoryResult = {
    items?: SandboxPaymentHistoryItem[];
    total?: number;
    page?: number;
    limit?: number;
};

export type ISandboxCourseRatingResult = {
    rating?: SandboxCourseRating;
    rating_avg?: number;
    rating_count?: number;
};

export interface ISandboxState {
    explore: ISandboxExploreResult | null;
    course: SandboxCourse | null;
    teacherDashboard: any;
    myEnrollments: any;
    myAssignments: any;
    teacherReviews: any;
    lessonProject: any;
    lessonAssignments: SandboxAssignmentSubmission[] | any;
    classAssets: ISandboxClassAssetsResult | null;
    paymentHistory: ISandboxPaymentHistoryResult | null;
    myOfficeHours: SandboxOfficeHoursConfig | null;
    teacherOfficeHours: SandboxOfficeHoursConfig | null;
    teacherAvailability: any;
    hostBookings: HostOfficeHoursBooking[] | null;
    studentBookings: StudentOfficeHoursBooking[] | null;

    fetchingExplore: boolean;
    fetchingCourse: boolean;
    fetchingTeacherDashboard: boolean;
    fetchingEnrollments: boolean;
    fetchingAssignments: boolean;
    fetchingTeacherReviews: boolean;
    fetchingHostBookings: boolean;
    fetchingStudentBookings: boolean;
    fetchingMyOfficeHours: boolean;
    fetchingPaymentHistory: boolean;
    mutating: boolean;
    error: IErrorType | null;
}
